// extracted by mini-css-extract-plugin
module.exports = {"container":"table-module--container--2pJ7b","table":"table-module--table--2ViaC","small":"table-module--small--wtSp8"};